import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'cm-carte',

  template: `
    <div class='cadre-carte'>  
       <agm-map 
            #gm
            [latitude]='lat' 
            [longitude]='lng'
            [zoom]='4'
            [styles]='styles'
            [mapTypeControl]="true"
            [fullscreenControl]="false"
            gestureHandling="greedy"
            (zoomChange)='changerZoom($event)'
            (mapClick)="fermeEcranInformationSite.emit()">

            <agm-marker 
                *ngFor='let site of sites; let i = index'
                [latitude]='toNumber(site.Latitude)'
                [longitude]='toNumber(site.Longitude)'
                [label]=''
                [iconUrl]="obtenirIconeMarqueur(site)"
                (markerClick)="afficherInformations(site)">
            </agm-marker>
        </agm-map>
    </div>
  `,

  styles: [`
    .cadre-carte {
        height: calc(100vh - 50px);
        width: calc(100vw - 60px);
        background-color: gray;
    }
    .sebm-google-map-container {
        height: calc(100vh - 50px);
    }
    @media (max-width: 800px), (max-height: 700px) {
      .cadre-carte {
            height: calc(100vh - 45px);
            width: 100vw;
            background-color: gray;
         }
      .sebm-google-map-container {
            height: calc(100vh - 45px);
            width: 100vw;
        }
    }
  `]
})
export class CarteComponent implements OnInit, OnChanges {

  @Input() sites: any[];
  @Output() afficheInformationSite: EventEmitter<any> = new EventEmitter();
  @Output() changeZoom: EventEmitter<number> = new EventEmitter();
  @Output() fermeEcranInformationSite: EventEmitter<any> = new EventEmitter();

  lat: number;
  lng: number;

  styles = [
          {
              'featureType': 'administrative',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#003f73'
                  },
                  {
                      'visibility': 'simplified'
                  }
              ]
          },
          {
              'featureType': 'administrative.country',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  }
              ]
          },
          {
              'featureType': 'administrative.country',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          },
          {
              'featureType': 'administrative.country',
              'elementType': 'labels.text',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  }
              ]
          },
          {
              'featureType': 'landscape.man_made',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#8da4ce'
                  }
              ]
          },
          {
              'featureType': 'landscape.natural',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  },
                  {
                      'color': '#e3ebfa'
                  }
              ]
          },
          {
              'featureType': 'poi',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          },
          {
              'featureType': 'road.highway',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  },
                  {
                      'hue': '#007dff'
                  }
              ]
          },
          {
              'featureType': 'road.highway',
              'elementType': 'labels.icon',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          },
          {
              'featureType': 'road.highway.controlled_access',
              'elementType': 'labels.icon',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'labels.icon',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          },
          {
              'featureType': 'road.local',
              'elementType': 'labels.icon',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          },
          {
              'featureType': 'transit',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'off'
                  }
              ]
          }
      ];

  constructor() {}

  ngOnInit() {
    this.lat = 45;
    this.lng = 0;
  }

  ngOnChanges() {
      if (this.sites && this.sites.length === 1) {
          this.lat = this.sites[0].Latitude;
          this.lng = this.sites[0].Longitude;
      }
  }

  changerZoom(zoom: number) {
    this.changeZoom.emit(zoom);
  }

  afficherInformations(site: any) {
    this.afficheInformationSite.emit(site);
  }

  obtenirIconeMarqueur(site: any): any {
    return './assets/images/' + site.TypeSite;
  }

  toNumber(value: string): number {
    return Number(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/carte.component.ts